import { queryClient } from '@hotjar/webapp/utils/react-query';
import { CURRENT_USER_QUERY_KEY } from '@hotjar/user';
import { bus, profileUpdated } from '@hotjar/webapp/utils/events';

/**
 * User service which returns data related to a User.
 */
angular.module('hjApp.user').service('User', [
    '$rootScope',
    'UserData',
    function ($rootScope, UserData) {
        var self = this;

        /**
         * Get the current user properties.
         */
        self.get = function () {
            var user = {
                countryCode: UserData.get('countryCode'),
                created: UserData.get('userCreated'),
                email: UserData.get('userEmail'),
                flags: {
                    emailBlocked: UserData.get('userEmailBlocked'),
                    // True if this user is an owner of any account. ToDo: This needs to change to User.xxx()
                    isAccountAdmin: UserData.get('isAccountAdmin'),
                    // True if this user has admin access on any Organization. ToDo: This needs to change to User.xxx()
                    isAdminOfOneOrganization: UserData.get('isAdminOfOneOrganization'),
                    // True if the user is a founding member.
                    // ToDo: This should be checked for specifically in that controller.
                    isFoundingMember: UserData.get('isFoundingMember'),
                    // True if the user should receive Analysis email notifications.
                    // ToDo: This should be checked for specifically in that controller.
                    receiveAnalysisEmails: UserData.get('receiveAnalysisEmails'),
                    // True if the user should receive Feedback email notifications.
                    // ToDo: This should be checked for specifically in that controller.
                    receiveFeedbackEmails: UserData.get('receiveFeedbackEmails')
                },
                id: UserData.get('userId'),
                ip: UserData.get('currentIp'),
                name: UserData.get('userName'),
                pictureUrl: UserData.get('userPictureUrl'),
                referralCode: UserData.get('referralCode'),
                role: UserData.get('userRole'),
                // True is user is authenticated with SSO and has not set a password
                isSSOOnly: UserData.get('isSSOOnly'),
                isEnterpriseSso: UserData.get('isEnterpriseSSO'),
                isEmailVerified: UserData.get('isEmailVerified'),
                tracking: {
                    utmParams: UserData.get('utmParams')
                }
            };

            return user;
        };

        /**
         * Set property/ies related to the user and broadcast an event.
         *
         * @param nameOrMap Key for property to set OR a map of key value pairs.
         * @param value Value to set OR undefined.
         * @return {object} Returns the updated User object.
         */
        self.set = function (nameOrMap, value) {
            var updatedUser;

            // Set UserData.
            // ToDo: UserData mapping needs to match the same structure of the User object
            //       so sub-objects can be updated using _.set() by using 'flags.property'.
            UserData.set(nameOrMap, value);

            // Get the updated user object.
            updatedUser = self.get();

            queryClient.invalidateQueries(CURRENT_USER_QUERY_KEY);

            // Broadcast an event and attach the updated object to it,
            // while also returning it to the caller.
            $rootScope.$broadcast('userUpdated', updatedUser);
            return updatedUser;
        };

        /**
         * Return a promise for organizations with the given access level.
         *
         * @param {string} access Access level this user has
         * @param {string} sortBy Sorting key
         */
        self.getOrganizationsWithAccess = function (access, sortBy) {
            return UserData.getOrganizations().then(function (organizations) {
                return self.filterOrganizationsWithAccess(organizations, access, sortBy);
            });
        };

        /**
         * Filters organizations with the given access level.
         *
         * @param {array} organizations Organizations to filter.
         * @param {string} access Access level this user has
         * @param {string} sortBy Sorting key
         */
        self.filterOrganizationsWithAccess = function filterOrganizationsWithAccess(organizations, access, sortBy) {
            access = access || 'admin';
            sortBy = sortBy || 'name';

            return _(organizations).filter({ access: access }).unique('id').sortBy(sortBy).value();
        };

        bus.subscribe(profileUpdated, ({ payload }) => {
            self.set(payload);
        });
    }
]);
